import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'aLaDateDu',
  standalone: true
})
export class ALaDateDuPipe implements PipeTransform {

  transform(value?: Date | string, ...args: unknown[]): string | undefined {
    return value instanceof Date ? `Au ${new DatePipe('fr').transform(value, 'dd/MM/yyyy')}` : value;
  }

}
